import { createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "mt_1" }
const _hoisted_2 = { class: "container" }
const _hoisted_3 = { class: "row mx_0_5" }
const _hoisted_4 = { class: "col_12 col_sm_8 p_0_5 text_end" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_router_link = _resolveComponent("router-link")!

  return (_openBlock(), _createElementBlock("footer", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("div", _hoisted_3, [
        _cache[5] || (_cache[5] = _createElementVNode("div", { class: "col_12 col_sm_4 p_0_5" }, [
          _createElementVNode("span", null, "TAEGUK Essen e.V. © 2025")
        ], -1)),
        _createElementVNode("div", _hoisted_4, [
          _createElementVNode("span", {
            class: "nav_link",
            onClick: _cache[0] || (_cache[0] = ($event: any) => (_ctx.$emit('edit-consent')))
          }, "Einwilligung ändern"),
          _cache[3] || (_cache[3] = _createTextVNode(" | ")),
          _createVNode(_component_router_link, {
            to: { name: 'datenschutz' },
            "active-class": "active",
            class: "nav_link"
          }, {
            default: _withCtx(() => _cache[1] || (_cache[1] = [
              _createTextVNode("Datenschutz")
            ])),
            _: 1
          }),
          _cache[4] || (_cache[4] = _createTextVNode(" | ")),
          _createVNode(_component_router_link, {
            to: { name: 'impressum' },
            "active-class": "active",
            class: "nav_link"
          }, {
            default: _withCtx(() => _cache[2] || (_cache[2] = [
              _createTextVNode("Impressum")
            ])),
            _: 1
          })
        ])
      ])
    ])
  ]))
}